// extracted by mini-css-extract-plugin
export default {"multipleList":"styles_multipleList__Ki5J0","keywordsList":"styles_keywordsList__UfovU","selected":"styles_selected__EbgGT"};